import React from "react";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Pencil } from "assets/icons";
import { IColumn } from "typings/global";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled";

const ColumnsTable = ({ handleClick }) => {
  const NAME = useTranslation({ id: "name" });
  const JOB_TITLE = useTranslation({ id: "job_title" });
  const PROFILE = useTranslation({ id: "profile" });
  const UNIT = useTranslation({ id: "unit" });
  const STATUS = useTranslation({ id: "status" });
  const ACTIVE = useTranslation({ id: "active" });
  const INACTIVE = useTranslation({ id: "inactive" });
  const ACTION = useTranslation({ id: "action" });
  const EDIT_USER = useTranslation({ id: "edit_user" });
  const collums: Array<IColumn> = [
    {
      title: NAME,
      dataIndex: "name",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      filterMultiple: false,
      render: (name: ColumnsType<any>) => `${name}`,
      width: "24%",
      key: "name",
    },
    {
      title: "E-mail",
      dataIndex: "email",
      sorter: (a: any, b: any) => a.email.localeCompare(b.email),
      filterMultiple: false,
      render: (email: ColumnsType<any>) => `${email}`,
      width: "18%",
      key: "email",
    },
    {
      title: JOB_TITLE,
      dataIndex: "jobTitle",
      sorter: (a: any, b: any) => a.jobTitle.localeCompare(b.jobTitle),
      filterMultiple: false,
      render: (jobTitle: ColumnsType<any>) => `${jobTitle}`,
      width: "9%",
      key: "jobTitle",
    },
    {
      title: PROFILE,
      dataIndex: "role",
      sorter: (a: any, b: any) => a.role.localeCompare(b.role),
      render: (role: ColumnsType<any>) => `${role}`,
      width: "14%",
      key: "role",
    },
    {
      title: UNIT,
      dataIndex: "locationDescription",
      sorter: (a: any, b: any) => a.locationDescription.localeCompare(b.locationDescription),
      filterMultiple: false,
      render: (locationDescription: ColumnsType<any>) => `${locationDescription}`,
      width: "22%",
      key: "locationDescription",
    },
    {
      title: STATUS,
      dataIndex: "active",
      key: "active",
      render: (active: boolean) => (active ? ACTIVE : INACTIVE),
      width: "10%",
    },
    {
      title: ACTION,
      dataIndex: "disabledEdit",
      sorter: false,
      width: "3%",
      key: "disabledEdit",
      render: (disabledEdit, record) =>
        !disabledEdit ? (
          <S.ActionContainer>
            <button onClick={() => handleClick(record)}>
              <Tooltip placement="top" title={EDIT_USER}>
                <Pencil className="pencilEdit" data-testid="editItemTable" />
              </Tooltip>
            </button>
          </S.ActionContainer>
        ) : (
          <S.ActionContainer>
            <button>
              <Pencil className="pencilDisabledEdit" data-testid="disabledEditItemTable" />
            </button>
          </S.ActionContainer>
        ),
    },
  ];
  return collums;
};

export default ColumnsTable;
